// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"1a289589","483":"c0345a83","787":"b804efcf"}[chunkId] + ".chunk.js";
};